import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import {
  _post,
  DeserializeVoid,
} from '../../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SetProjectNeedsDesignControllerRequestService {
  private static BASE_URL = '/projects';
  private readonly post: <T>(
    path: string,
    body: any,
    deserialize: (response: any) => T
  ) => Observable<T>;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      SetProjectNeedsDesignControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public setProjectNeedsDesign(
    projectId: number,
    designerId: number | null,
    designByDate: Date | null,
    needsDesignDescription: string | null
  ): Promise<void> {
    return this.post(
      '/setNeedsDesign',
      {
        projectId: projectId,
        designerId: designerId,
        designByDate: designByDate,
        needsDesignDescription: needsDesignDescription,
      },
      DeserializeVoid
    ).toPromise();
  }
}
